import { createI18n } from '@aslen/core/i18n';

const saved = (() => {
  try {
    return localStorage.getItem('aslen.lang');
  } catch {
    return null;
  }
})();

export const i18n = createI18n(saved === 'en' ? 'en' : 'tr');
document.documentElement.lang = i18n.language;

export function setLanguage(lng: 'tr' | 'en') {
  void i18n.changeLanguage(lng);
  document.documentElement.lang = lng;
  try {
    localStorage.setItem('aslen.lang', lng);
  } catch {
    /* ignore */
  }
}

export function currentLocale(): 'tr' | 'en' {
  return i18n.language === 'en' ? 'en' : 'tr';
}
